import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={80}
    height={80}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Circle cx={40} cy={40} r={40} fill="#00813B" />
    <Path
      d="M31.3833 47.1303C31.5814 47.3503 31.7574 47.5704 31.9775 47.8345C32.6157 47.1743 33.1659 46.5801 33.672 45.9859C40.5821 38.4817 47.4701 30.9554 54.3802 23.4512C55.4145 22.3288 56.6469 21.6246 58.2094 21.6686C59.9479 21.7347 61.2463 22.6369 61.9285 24.1994C62.6547 25.8499 62.4346 27.4564 61.2023 28.8428C59.1777 31.1095 57.109 33.3541 55.0624 35.5988C48.7465 42.5309 42.4086 49.485 36.0707 56.4171C35.4765 57.0553 34.8824 57.6934 34.1782 58.1556C32.5937 59.2119 30.5031 59.0359 29.1607 57.6714C27.5542 56.043 26.0577 54.3044 24.5173 52.6099C22.3386 50.1672 20.1379 47.7245 17.9593 45.2817C16.3968 43.5432 16.2428 41.1225 17.5412 39.406C19.1477 37.2273 22.5587 37.2053 24.4953 39.3619C26.8059 41.9367 29.0946 44.5335 31.3833 47.1303Z"
      fill="white"
    />
  </Svg>
);
export default SVGComponent;
